import { useState } from 'react';
import axios from 'Axios';
import { FileText } from 'tabler-icons-react';
import { clx, api, toastify } from 'Utils';
import { AddStoryBox, FieldMessage } from 'Elements';
import styles from 'partials/dashboard/user-form.module.scss';

export const AddStoryText = ({ onAdd, onRemove, storyId, ...props }) => {
	const [state, setState] = useState({
		fields: {
			title: '',
			body: '',
			narator: ''
		},
		disabled: false,
		errors: {}
	});

	const handleInput = (e) => {
		const fields = state.fields;
		const target = e.target;
		fields[target.name] = target.value;
		setState((prev) => ({
			...prev,
			fields
		}));
	};

	const validateForm = () => {
		let errors = {};
		const fields = state.fields;
		let formIsValid = true;
		if (!fields.title) {
			formIsValid = false;
			errors['title'] = 'عنوان محتوا را وارد کنید';
		}
		if (!fields.body) {
			formIsValid = false;
			errors['body'] = 'متن محتوا را وارد کنید';
		}

		setState((prev) => ({
			...prev,
			errors
		}));
		return formIsValid;
	};

	const submitForm = () => {
		const data = {
			...state.fields,
			...{
				story_id: storyId,
				content_type: props.type
			}
		};
		if (validateForm()) {
			setState((prev) => ({
				...prev,
				disabled: true
			}));

			axios.post(api.storeStory, data).then((res) => {
				const data = res.data;
				if (data.success) {
					setState((prev) => ({
						...prev,
						disabled: false
					}));
					toastify(
						<>
							<p>ثبت متن با موفقیت انجام شد</p>
							<p>متن شما بعد از تایید ناظر در سایت نمایش داده می شود</p>
						</>,
						'success'
					);
				}
			});
		}
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		submitForm();
	};

	return (
		<AddStoryBox
			type="text"
			icon={FileText}
			index={props.index}
			disabledSubmit={state.disabled}
			onAdd={onAdd}
			onSubmit={handleSubmit}
			onRemove={onRemove}>
			<div className="row">
				<div className="col-sm-6 mb-xxs-15">
					<div className={styles.field}>
						<label htmlFor={`title_${props.index}`} className={styles.label}>
							عنوان
						</label>
						<input
							type="text"
							id={`title_${props.index}`}
							name="title"
							className={styles.input}
							onChange={handleInput}
						/>
						{state.errors.title && (
							<FieldMessage text={state.errors.title} />
						)}
					</div>
				</div>
				<div className="col-sm-6 mb-xxs-15">
					<div className={styles.field}>
						<label htmlFor={`narator_${props.index}`} className={styles.label}>
							توضیحات
						</label>
						<input
							type="text"
							id={`narator_${props.index}`}
							name="narator"
							placeholder="اگر متن دارای راوی یا توضیحات خاصی می باشد در این بخش درج نمایید"
							className={styles.input}
							onChange={handleInput}
						/>
					</div>
				</div>
				<div className="col-sm-12 mt-15">
					<div className={styles.field}>
						<label htmlFor={`body_${props.index}`} className={styles.label}>
							متن
						</label>
						<textarea
							name="body"
							id={`body_${props.index}`}
							className={clx(
								styles.input,
								styles.textarea
							)}
							cols="10"
							rows="5"
							onChange={handleInput}
						/>
						{state.errors.body && (
							<FieldMessage text={state.errors.body} />
						)}
					</div>
				</div>
			</div>
		</AddStoryBox>
	);
};
